import { CHECADOR } from "../../Constants/Endpoinst";
import { ApiRequestInterceptor } from "../apiRequest";

const parseChecadorResponse = (response) => {
    if (response?.code === 200 && response?.data) {
        return response.data;
    }

    if (response?.statusCode === 200 && response?.body) {
        return JSON.parse(response.body);
    }

    const errorMessage =
        response?.data?.error ||
        response?.body ||
        "Error al obtener datos del checador";

    throw new Error(errorMessage);
};

export const fetchChecador = async (numeroEmpleado) => {
    const method = "GET";

    const path = numeroEmpleado
        ? CHECADOR.getChecadorPorEmpleado(numeroEmpleado)
        : CHECADOR.getChecador;

    const response = await ApiRequestInterceptor(
        path,
        method
    );

    return parseChecadorResponse(response);
};

// Trae checadas de TODOS los empleados pero acotadas a un rango de fechas
// (ej. el mes visible en el calendario general), en vez de la historia completa.
export const fetchChecadorPorRango = async (startDate, endDate) => {
    const method = "GET";

    const response = await ApiRequestInterceptor(
        CHECADOR.getChecadorPorRango(startDate, endDate),
        method
    );

    return parseChecadorResponse(response);
};